/**
 * InkDyno CDN Gallery Injector v5 — Simple & Robust
 *
 * Strategy: Liquid template now renders ALL Shopify images natively for
 * T-Shirt products (bypassing hide_variants). Server already creates the
 * thumbnail slider. This script ONLY appends CDN images + re-injects
 * after Dawn's variant-change section re-render.
 *
 * No MutationObserver. No thumbnail slider creation. No single-mode fixes.
 */
(function () {
  'use strict';

  var cdnData = null;
  var isInjecting = false;
  var sectionId = '';

  function parseCDNData() {
    if (cdnData) return cdnData;
    var script = document.getElementById('inkdyno-cdn-images');
    if (!script) return null;
    try {
      cdnData = JSON.parse(script.textContent);
    } catch (e) {
      console.warn('[CDN v5] Parse error', e);
      return null;
    }
    return cdnData;
  }

  /* Clean existing CDN items from DOM */
  function cleanCDN() {
    document.querySelectorAll('.is-cdn-image').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.is-cdn-thumb').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.is-cdn-modal').forEach(function (el) { el.remove(); });
  }

  function inject() {
    var data = parseCDNData();
    if (!data || !data.length) return;
    if (isInjecting) return;
    isInjecting = true;

    var gallery = document.querySelector('.product__media-list');
    if (!gallery) { isInjecting = false; return; }

    /* Clean any leftover CDN items first */
    cleanCDN();

    var mediaGallery = gallery.closest('media-gallery');
    sectionId = mediaGallery ? mediaGallery.id.replace('MediaGallery-', '') : '';
    var thumbList = document.querySelector('#Slider-Thumbnails-' + sectionId);
    var modal = document.querySelector(
      '#ProductModal-' + sectionId + ' .product-media-modal__content'
    ) || document.querySelector('.product-media-modal__content');

    /* Copy zoom/fit settings from existing Shopify items */
    var zoomSetting = 'lightbox';
    var icon = gallery.querySelector('.product__media-icon');
    if (icon && icon.className.indexOf('hover') > -1) zoomSetting = 'hover';
    var zoomSvg = '';
    var svgEl = gallery.querySelector('.product__media-icon .svg-wrapper');
    if (svgEl) zoomSvg = svgEl.innerHTML;
    var mediaFit = 'contain';
    var container = gallery.querySelector('.product-media-container');
    if (container && container.className.indexOf('cover') > -1) mediaFit = 'cover';

    var count = 0;
    data.forEach(function (img, idx) {
      var cdnId = 'cdn-' + idx;
      var slideId = sectionId + '-' + cdnId;
      var alt = (img.alt || '')
        .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
        .replace(/</g, '&lt;').replace(/>/g, '&gt;');

      /* ── Gallery slide ── */
      var li = document.createElement('li');
      li.id = 'Slide-' + sectionId + '-' + cdnId;
      li.className = 'product__media-item grid__item slider__slide is-cdn-image';
      li.setAttribute('data-media-id', slideId);
      li.innerHTML =
        '<div class="product-media-container media-type-image media-fit-' + mediaFit +
        ' global-media-settings gradient" style="--ratio:1;--preview-ratio:1;">' +
        '<modal-opener class="product__modal-opener product__modal-opener--image" ' +
        'data-modal="#ProductModal-' + sectionId + '">' +
        '<span class="product__media-icon motion-reduce quick-add-hidden product__media-icon--' +
        zoomSetting + '" aria-hidden="true"><span class="svg-wrapper">' + zoomSvg + '</span></span>' +
        '<div class="product__media media media--transparent">' +
        '<img src="' + img.url + '" alt="' + alt +
        '" loading="lazy" width="1200" height="1200" class="image-magnify-' + zoomSetting + '">' +
        '</div>' +
        '<button class="product__media-toggle quick-add-hidden product__media-zoom-' +
        zoomSetting + '" type="button" aria-haspopup="dialog" data-media-id="' + cdnId +
        '"><span class="visually-hidden">Open media</span></button>' +
        '</modal-opener></div>';
      gallery.appendChild(li);

      /* ── Thumbnail ── */
      if (thumbList) {
        var tli = document.createElement('li');
        tli.id = 'Slide-Thumbnails-' + sectionId + '-cdn-' + idx;
        tli.className = 'thumbnail-list__item slider__slide is-cdn-thumb';
        tli.setAttribute('data-target', slideId);
        tli.setAttribute('data-media-position', String(idx + 100));

        var btn = document.createElement('button');
        btn.className = 'thumbnail global-media-settings global-media-settings--no-shadow';
        btn.setAttribute('aria-controls', 'GalleryViewer-' + sectionId);
        btn.innerHTML =
          '<img src="' + img.url + '" alt="' + alt +
          '" loading="lazy" width="104" height="104">';

        /* Click → navigate to this CDN image */
        (function (targetSlideId) {
          btn.addEventListener('click', function () {
            if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
              mediaGallery.setActiveMedia(targetSlideId, false);
            }
          });
        })(slideId);

        tli.appendChild(btn);
        thumbList.appendChild(tli);
      }

      /* ── Modal ── */
      if (modal) {
        var mdiv = document.createElement('div');
        mdiv.className = 'product-media-modal__content-item is-cdn-modal';
        mdiv.setAttribute('data-media-id', slideId);
        mdiv.innerHTML =
          '<img src="' + img.url + '" alt="' + alt +
          '" loading="lazy" width="1200" height="1200">';
        modal.appendChild(mdiv);
      }

      count++;
    });

    /* Re-init slider pagination after adding items */
    if (thumbList) {
      var ts = thumbList.closest('slider-component');
      if (ts) {
        ts.classList.remove('thumbnail-slider--no-slide');
        if (typeof ts.initPages === 'function') ts.initPages();
        if (typeof ts.resetPages === 'function') ts.resetPages();
      }
    }
    var ms = gallery.closest('slider-component');
    if (ms) {
      if (typeof ms.initPages === 'function') ms.initPages();
      if (typeof ms.resetPages === 'function') ms.resetPages();
    }

    isInjecting = false;
    console.log('[CDN v5] Injected', count, 'images');
    document.dispatchEvent(new CustomEvent('inkdyno:cdn-images-injected', {
      detail: { count: count }
    }));
  }

  /* ── Re-inject after Dawn's variant change ──
     Dawn's product-info.js updateMedia() removes CDN items because they
     don't exist in the newly fetched section HTML. We simply wait for
     Dawn to finish, then re-inject. */
  function onVariantChange() {
    setTimeout(function () {
      inject();
    }, 350);
  }

  /* Subscribe to Dawn's variant change event */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  /* Initial injection */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
